<template>
  <div>
	<div ref="h_top">
		<van-nav-bar class="bg-gradual-blue" fixed placeholder title="场馆预约" left-text="返回" @click-left="goback();" left-arrow />
	
   
    <div>
      <van-image style="height: 150px;width: 100%;" fit="cover" :src="sroom.imgUrl" />
    </div>
    <div style="margin-top: 5px;background-color: #ffffff;border-bottom: 1px dashed #ccc;">
      <div style="padding: 5px;color:blue;font-size: 18px;">{{sroom.name}}</div>
      <div style="padding: 5px;color:#000000;font-size: 14px;">{{sroom.schoolName}} {{sroom.libraryName}} {{sroom.positionDesc}}</div>
      <div style="padding: 5px;color:#999;font-size: 14px;">{{sroom.sroomDesc}}</div>
    </div>
    <div  style="margin-top: 5px;background-color: #ffffff;border-bottom: 1px dashed #ccc;border-top: 1px dashed #ccc;">
      <van-tabs @click="chageDate" v-model="curDate" clss="date_c" background="#b9d4ed" line-width="0px" title-active-color="blue">
        <van-tab v-for="item in resDayList" :title="item.sDate" :name="item.pDate"></van-tab>
      </van-tabs>
    </div>
    <div class="list_div1">
      <span style="padding:0 5px;width:10px;height:10px;background-color:#ffffff; border:1px solid #e6eff7;">&nbsp;</span>
      <span style="margin-left:2px;margin-right:10px;">可预约</span>
      <span style="padding:0 5px;width:10px;height:10px;background-color:#004687; border:1px solid #e6eff7;">&nbsp;</span>
      <span style="margin-left:2px;margin-right:10px;">已预约</span>
      <span style="padding:0 5px;width:10px;height:10px;background-color:#f3f3f3; border:1px solid #e6eff7;">&nbsp;</span>
      <span style="margin-left:3px;">不可预约</span>
    </div>
	
	</div>
    
    <div ref="h_cont" class="table_div con" style="padding-bottom: 20px;margin:0 5px;overflow-y: auto;">
      <div class="table">
        <div v-for="(item,idx) in showList">
          <div class="tr">
            <div v-if="item.idx % 2 == 0 || idx == 0" class="td td_l">{{item.time}}</div>
            <div v-else class="td td_l">&nbsp;</div>
            <div @click="NextStep(item)" class="td td_r" :class="{'td_color_1':item.state == 1 , 'td_color_2':item.state == 2 , 'td_color_3':item.state == 3}">{{item.stateName}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { loadData , showToast , hideToast } from '@/utils/common'
import Sroom from '@/utils/cg'

export default {
  props: {
    sroom: {
      type: Object,
      default: () => {}
    }
  },
  components: { Sroom  },
  data() {
    return {
      loading: false,
      finished: false,
      roomList:[],
      resDayList:[],
      curDate:null,
      limitData:{},
      showList:[]
    }
  },
  mounted() {
	this.initScreenH();
    this.init();
  },
  beforeDestroy() {

  },
  methods: {
	initScreenH(){
	  let fh = document.documentElement.clientHeight;
	  let bh = this.$store.state.bottomH;
	  let th = this.$refs.h_top.offsetHeight;
	  this.$refs.h_cont.style.height = (fh - th - bh)+'px';
	  this.$refs.h_cont.style.paddingBottom = bh+'px';
	},
    init(){
      let _this = this;
	  let dLimt = parseInt(sessionStorage.getItem("config_sroom_maxday"));
	  dLimt = dLimt ? dLimt : 7;
      Sroom.getResDayList(dLimt, function (res) {
        if (res && res.length > 0) {
          _this.resDayList = res;
          _this.curDate = res[0].pDate;
          _this.chageDate(res[0].pDate,res[0].sDate);
        }
      });
    },
    chageDate(name, title){
      let _this = this;
      Sroom.getResLimitData(this.sroom.id, name,function(res){
        if(res){
          _this.limitData = res;
          Sroom.getShowList(res.minH,res.maxH, res.reseArr, function(res){
            _this.showList = res;
          });
        }
      });
    },
    NextStep(obj){
      let _this = this;
      if (obj && obj.state == 0){
        let ldata = this.limitData;
        Sroom.getEndIndex(obj.idx, ldata.maxReserve, ldata.reseArr, ldata.maxH, function(res){
          let resParam = {};
          resParam.reserveDate = _this.curDate;
          resParam.startIndex = obj.idx;
          resParam.endIndex = res;
          resParam.endSidx = parseInt(obj.idx) + parseInt(ldata.minReserve)*2;
          resParam.sroomId = _this.sroom.id;
          _this.$emit("notice",  {'page':'detail','rdata':resParam});
        });
      }
    },
    goback(){
      this.$emit("notice",  {'page':'detail','isback':'1'})
    }
  }
}
</script>

<style>
  .van-tab--active{
    background-color: #439adf !important;
  }
  .list_div1 {
    width:100%;
    margin:auto;
    text-align:center;
    background-color:#fff;
    padding-top:10px;
    padding-bottom:10px;
  }


  .table {
  width:88%;
  margin:auto;
  border-top: 1px #e6eff7 solid;
  border-left: 1px #e6eff7 solid;
}
.tr {
 display: flex;
 width: 100%;
 justify-content: center;
 height: 80rpx;
 align-items: center;
 border-bottom: 1px #e6eff7 solid;
}
.td {
 height:  80rpx;
 line-height: 80rpx;
 justify-content: center;
 text-align: center;
 border-right: 1px #e6eff7 solid;
 padding: 10px;
}
.td_color_1{
   background-color: #004687;
}
.td_color_2{
   background-color: #f3f3f3;
}

.td_l{
  width: 40%;
}
.td_r{
  width: 60%;
}
.bg-w{
 background: snow;
}
.bg-g{
 background: #E6F3F9;
}
.th {
 width: 40%;
 justify-content: center;
 background: #3366FF;
 color: #fff;
 display: flex;
 height: 3rem;
 align-items: center;
}


.table1 {
   width:88%;
   margin:auto;
   border: 1px #e6eff7 solid;
   border-collapse: collapse;
}
.table1 td{
  height:36px;
  line-height:36px;
  font-size:14px;
  width:35%;
  background-color:#fff;
  text-align:center;
  border: 1px #e6eff7 solid;
}
.table1 td.other{
  height:36px;
  line-height:36px;
  font-size:14px;
  background-color:#004687;
  width:63%;
}
.input2 {
  width:80px;
  border:1px solid #000;
  background-color:#ccc;
  height:26px;
  line-height:26px;
  font-size:13px;
}
.table_div {
  background-color:#fff;
  margin:auto;
}


.con{
  padding-bottom: 110rpx;
  padding-bottom: calc(110rpx + env(safe-area-inset-bottom) / 2);
}
</style>
